import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import SocialIcons from './SocialIcons';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    color: '#e3e9ec'
  },
  title: {
    paddingTop: theme.spacing(2),
  },
  subtitle: {
    paddingTop: theme.spacing(1) / 2,
  },
  hashTag: {
    paddingTop: theme.spacing(2),
  },
  link: {
    paddingTop: theme.spacing(1) / 2,
    paddingBottom: theme.spacing(3),
  },
  corrivium: {
    paddingTop: theme.spacing(2),
  },
  rights: {
    paddingTop: theme.spacing(1) / 2,
  },
  privacy: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  href: {
    color: 'inherit',
    textDecoration: 'none',
    "&:hover": {
      color: '#fff',
      textDecoration: 'underline'
    }
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container>
        <Grid container direction="row" justify="space-between">
          <Grid item>
            {props.config &&
              <>
                <div className={classes.title}><h2><a href={props.config.url} target="_blank" rel="noopener noreferrer" className={classes.href}>{props.config.name}</a></h2></div>
                <div className={classes.hashTag}><h4><a href={`https://twitter.com/search?q=${props.config.hashTag}`} target="_blank" rel="noopener noreferrer" className={classes.href}>#{props.config.hashTag}</a></h4></div>
                <div className={classes.link}><h4><a href={props.config.url} target="_blank" rel="noopener noreferrer" className={classes.href}>{props.config.urlLabel}</a></h4></div>
                <SocialIcons config={props.config} />
              </>
            }
          </Grid>
          <Grid item>
            <div className={classes.corrivium}><h4 style={{ fontWeight: 400 }}>Powered by <a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer" className={classes.href} style={{ fontWeight: 700 }}>Corrivium Live</a></h4></div>
            <div className={classes.rights}><h5 style={{ fontWeight: 400 }}>&copy; Copyright 2020. All Rights Reserved</h5></div>
            <div className={classes.privacy}><h5><a href="https://www.corrivium.com/privacy" target="_blank" rel="noopener noreferrer" className={classes.href}>Privacy Policy</a></h5></div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

